import generalOne from "../../images/mision.jpg";
import generalTwo from "../../images/vision.jpg";
import generalThree from "../../images/general-three.jpg";
import generalFour from "../../images/general-four.jpg";

export default function MissionAndVision() {
  return (
      <div className="d-flex bg-body-tertiary flex-lg-row flex-column mx-lg-5 mx-0 my-4">
        <div className="w-100 px-md-5 px-4 py-4">
          <h3 className="text-uppercase">Vision</h3>
          <p className="fs-5 text-light-emphasis">
            To be a leading trading company recognized globally for innovation, reliability, and excellence in delivering quality products and sustainable solutions.

          </p>
       
          <h3 className="text-uppercase">Mission</h3>
          <p className="fs-5 text-light-emphasis">
            • To connect global suppliers with regional businesses, fostering long-term partnerships.
          </p>

          <p className="fs-5 text-light-emphasis">
            • To continuously expand our portfolio with innovative and sustainable products.
          </p>

          <p className="fs-5 text-light-emphasis">
            • To contribute to the economic development of our region through quality and trust.
          </p>
        </div>
        <div className="w-100 overflow-hidden">
          <img
            className="w-100 h-100 object-fit-cover"
            src={generalTwo}
            alt="generalTwo"
            loading="lazy"
          />
        </div>
      </div>
  );
}
